import OurMission from '@components/containers/about/OurMission';
import Team from '@components/containers/about/Team';
import JoinUs from '@components/containers/about/JoinUs';
import CommunityBar from '@components/common/CommunityBar';
import Investors from '@components/containers/about/Investors';
import Head from 'next/head';
import { HeroWrapper, Hero, HeroText, StyledCard } from '@components/containers/about/About.styles';
import Container from '@components/common/Container';
import Image from 'next/image';

export default function About() {
  return (
    <>
      <Head>
        <title>About ArchimedesFi</title>
        <meta name="description" content="About ArchimedesFi. Our team and values." />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Hero>
        <Container>
          <HeroWrapper>
            <HeroText>
              <section>
                <h2>Our Story</h2>
                <p>Archimedes Finance was born from a moment of Eureka.</p>
                <p>
                  As early DeFi adopters, we had growing concerns that the ecosystem is not sustainable; the
                  lending/borrowing markets offer decreasing yields from bonus tokens and poor UX.
                </p>
                <p>
                  We are Archimedes, the father of leverage: we optimize capital efficiency, generating yield from real
                  economic activity. Our mathematical g(r)eekness and simple UI achieves high long lasting opportunities
                  for all while mitigating some of the risks in the space.
                </p>
                <p>Eureka!</p>
              </section>
            </HeroText>
            <img src="/about-hero.svg" alt="Archimedes" />
          </HeroWrapper>
        </Container>
      </Hero>
      <OurMission />
      <Team />
      <JoinUs />
      <CommunityBar />
      <Investors />
    </>
  );
}
